import { render, staticRenderFns } from "./PacketCheck.vue?vue&type=template&id=2acf8f0c"
import script from "./PacketCheck.vue?vue&type=script&lang=js"
export * from "./PacketCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports